<section *ngIf="processing">
  <h2>{{processingMessage}}...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>

<section *ngIf="!processing">
  <mat-card fxFlex="100" fxFlex.lt-sm="100">
    <mat-card-title>
      <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="75.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <span style="font-size: larger"><mat-icon>beenhere</mat-icon> {{letter.letterType}} Letter
            <span *ngIf="voucher != undefined && voucher != null"> - {{voucher?.voucherId}}</span>
            <span *ngIf="voucherApplication != undefined && voucherApplication != null"> - {{voucher?.voucherId}}</span>
            <span *ngIf="household != undefined && household != null"> - {{voucher?.voucherId}}</span>
            Sent Info</span>
        </div>
        <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
          <button mat-button mat-raised-button color="primary" aria-label="Save" (click)="updateLetter()" [disabled]="processing">Save</button> &nbsp;
          <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel">Cancel</button>
        </div>
      </div>
      <hr />
    </mat-card-title>
    <mat-card-content>
      <form #form="ngForm" [formGroup]="sendLetterForm" class="form-field-full">
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Contacted/Sent Date</mat-label>
              <input id="contactDate" name="contactDate" formControlName="contactDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerContactDate" />
              <mat-datepicker-toggle matSuffix [for]="datepickerContactDate"></mat-datepicker-toggle>
              <mat-datepicker #datepickerContactDate>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>

          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Contacted/Sent Method</mat-label>
              <mat-select formControlName="contactType">
                <mat-option *ngFor="let item of contactMethods" value="{{item}}">{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Comments</mat-label>
              <textarea rows="3" cols="100" placeholder="Comments" formControlName="contactComment" value="{{sendLetterForm.value.contactComment}}" matInput></textarea>
            </mat-form-field>
          </div>
        </div>

        <hr />

        <div>
          <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
            <span>You can send this letter as an email attachment:
            </span>
            <br />
          </div>
          <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
            <p color="primary">
              <strong>Note:</strong> Sending as an attachment will update the values above, setting the
              <strong>Contacted/Sent Date</strong> to <strong>today</strong> and the <strong>Contacted/Sent
                Method</strong> to <strong>Email</strong>.
            </p>
            <br />
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="100" fxFlex.lt-sm="100">
              <button mat-button mat-raised-button color="primary" aria-label="Send" [disabled]="processing" *ngIf="applicantContactEmail != null && applicantContactEmail.length > 0"
                (click)="emailLetter()"><mat-icon>email</mat-icon> Send As Attachment to:
                <span>{{applicantContactEmail}}</span>
              </button>

              <div *ngIf="voucher != undefined && voucher != null && voucher.voucherApplication.applicationType == voucherService.lubgwmaTestingVoucherType 
                            && letter.letterType == voucherService.lubgwmaTreatmentLetterType">
                <span *ngIf="applicantContactEmail != null && applicantContactEmail.length > 0"><br /><br /></span>
                <span *ngIf="applicantContactEmail != null && applicantContactEmail.length > 0">OR</span>
                <mat-form-field appearance="standard">
                  <mat-label>Select Treatment Contractor Email</mat-label>
                  <select formControlName="treatmentContractorEmail" (change)="setTreatmentContractor()" matNativeControl>
                    <option *ngFor="let item of treatmentContractorEmails" value="{{item}}">{{item}}</option>
                  </select>
                </mat-form-field>
                <br />
                <button mat-button mat-raised-button color="primary" aria-label="Send" [disabled]="processing" (click)="emailTreatmentContractorLetter()"><mat-icon>email</mat-icon> emnt
                  Send As Attachment to Treatment
                  Contractor</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</section>